export default {"src":"/_next/static/media/amenityIcon-presentation.5474801f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};